import {useSelector} from 'react-redux';

import {selectCurrentLanguageCode} from 'coreStore/data/configurations';

/**
 * Atomic hook that returns only the current language code.
 * Avoids the overhead of useLocalesMgr (4 useSelector calls)
 * when only the language code string is needed.
 */
const useLanguageCode = (): string =>
	useSelector(selectCurrentLanguageCode) || 'en';

export default useLanguageCode;
